import React from 'react';
import { IcertificateDetails } from '../../TypesAndInterfaces';
import CertificateThumbnail from './CertificateThumbnail';
import { getCertificatePdfUrl } from '../utils/certificateUtils';
import { sendCertificateThumbnailClickedEvent } from '../utils/certificateGAEvents';

interface CertificateThumbnailListProps {
  certificates: IcertificateDetails[];
  selectedIndex: number;
  onSelect: (index: number) => void;
  isCareerPath: boolean;
}

const CertificateThumbnailList: React.FC<CertificateThumbnailListProps> = ({
  certificates,
  selectedIndex,
  onSelect,
  isCareerPath,
}) => {
  if (certificates.length <= 1) {
    return null;
  }

  const partnerCertCount = certificates.filter((c) => c.isPartnerCertificate).length;

  const handleThumbnailClick = (cert: IcertificateDetails, index: number) => {
    // Track thumbnail click event
    sendCertificateThumbnailClickedEvent({
      certificate_id: cert.certificate?.id,
      certificate_index: index,
      certificate_type: cert.certificate?.type || cert.certificateType,
      course_name: cert.courseName,
      course_id: cert.certificate?._id,
      partner_certs_available_count: partnerCertCount,
      is_partner_certificate: cert.isPartnerCertificate,
      partner_name: cert.partnerName,
    });
    onSelect(index);
  };

  return (
    <div className="flex gap-4 mt-4 overflow-x-auto p-5 w-full">
      {certificates.map((cert, idx) => (
        <CertificateThumbnail
          key={`cert-thumb-${cert.certificate?.id || idx}-${cert.certificate?._id || ''}`}
          certificate={cert}
          isSelected={idx === selectedIndex}
          onClick={() => handleThumbnailClick(cert, idx)}
          pdfUrl={getCertificatePdfUrl(cert.certificate?.id || '', isCareerPath)}
          index={idx}
        />
      ))}
    </div>
  );
};

export default CertificateThumbnailList;
